import { Subject } from 'rxjs';

import { Directive } from '@angular/core';

@Directive()
export abstract class DrawerInitDirective<T> {
  readonly close$ = new Subject<T | undefined>();

  abstract drawerInit(...args: unknown[]): void;
}
